import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/auth-context";
import { ScopeProvider } from "@/contexts/scope-context";
import { AppRouter } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ScopeProvider>
            <AppRouter />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: { fontFamily: "var(--font-sans)" },
              }}
            />
          </ScopeProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
